import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ComponentsModule } from 'src/app/components/components.module';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { UnauthorizedInterceptor } from 'src/app/interceptor/unauthorized.interceptor';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AppToastrService } from 'src/app/services/app-toastr.service';
import { AppRoutingModule } from '../../app.routing';
import { AdminLayoutComponent } from './admin-layout.component';
import { ModalModule } from 'src/app/modal/modal.module';

@NgModule({
  imports: [
    CommonModule,
    ToastrModule.forRoot({ timeOut: 500 }),
    ComponentsModule,
    AppRoutingModule,
    CustomPipesModule,
    MatSidenavModule,
    ComponentsModule,
    ModalModule,
  ],
  declarations: [AdminLayoutComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    { provide: ToastrService, useClass: AppToastrService },
  ],
  exports: [AdminLayoutComponent],
})
export class AdminLayoutModule {}
